<template>
  <v-menu offset-y>
    <template #activator="{ props }">
      <v-btn icon v-bind="props" aria-label="Change language menu">
        <v-img
          class="locale-switcher"
          width="24"
          height="24"
          :src="localeImage"
          alt="Change language"
        />
      </v-btn>
    </template>
    <v-list min-width="80">
      <v-list-item
        v-for="(item, index) in localeItems"
        :key="index"
        @click="changeLocale(item.code)"
        :aria-label="item.altText"
      >
        <template #prepend>
          <v-img
            class="locale-switcher__item"
            width="24"
            height="24"
            :src="item.img"
            :alt="item.altText"
          />
        </template>
        <v-list-item-title class="ml-2">{{ item.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import enImg from '@/assets/en.png';
import esImg from '@/assets/es.png';

export default {
  name: 'LocaleSwitcher',
  data: () => ({
    localeItems: [
      {
        title: 'En',
        code: 'en',
        altText: 'English',
        img: enImg,
      },
      {
        title: 'Es',
        code: 'es',
        altText: 'Español',
        img: esImg,
      },
    ],
  }),
  methods: {
    changeLocale(lang) {
      if (this.$vuetify?.locale) {
        this.$vuetify.locale.current = lang;
      }
      this.$store.dispatch('SET_LANG', lang);
    },
  },
  computed: {
    currentLocale() {
      return (this.$store?.state?.common?.lang || this.$vuetify?.locale?.current || 'en').toLowerCase();
    },
    localeImage() {
      const currentLocale = this.localeItems.find(item => item.code === this.currentLocale);
      return (currentLocale && currentLocale.img) || enImg;
    },
  },
};
</script>

<style scoped lang="scss">
.locale-switcher {
  display: block;

  &__item {
    display: block;
  }
}
</style>